// extracted by mini-css-extract-plugin
export default {"wrapper":"bT5NcI0yRiWwCOvss91d","passwordRules":"k_RQfBNzRr4v6FdRQfcB","submitBtn":"mt_73f89I_TTHL22kclw"};